import React from 'react';

import { Icon } from '~/packages/common-frontend/components/icons';
import { GlobalNavRouterLinkItem } from '~/packages/common-frontend/layout';

type Props = {
  /** Pass `'sm'` to render as a muted secondary-group item (lender sidebar). */
  size?: React.ComponentProps<typeof GlobalNavRouterLinkItem>['size'];
};

export const DataPipelineNavItem = ({
  size,
}: Props = {}): React.ReactElement => {
  return (
    <GlobalNavRouterLinkItem
      to="/data-pipeline"
      label="Data Pipeline"
      icon={<Icon icon="share-nodes" />}
      size={size}
    />
  );
};
